const notice = {
  notificationType: "通知类型",
  notificationType1: "安全模式报警",
  notificationType3: "安全提醒",
  notificationType4: "地理围栏提醒",
  notificationType5: "离线/在线报警",
  notificationType6: "活动提醒 ",
  notificationType7: "系统消息",
  notificationType8: "超速报警",
  notificationType9: "行程结束",
  isdisabled: "账号状态",
  title: "标题",
  content: "内容",
  pushOrNot: "是否推送",
  readOrNot: "是否已读",
  search: {
    width1: "60px",
    width2: "60px",
    width3: "60px",
    width4: "75px"
  },
  yes: "是",
  no: "否",
  dialog: {
    pushTitle: "推送标题",
    pushContent: "推送内容",
    selectUsers: "选择用户",
    pushAll: "是否推送全部用户",
    noTitle: "请输入标题",
    noContent: "请输入内容",
    noUser: "请选择用户",
    labelWidth: "130px"
  },
  user: {
    loginName: "用户名称",
    disableOrNot: "是否禁用"
  }
} 
export default notice